<template>
  <div class="share-container change-perms-view">
    <van-nav-bar
      class="file-header nav-bar-bgcolor"
      :title="$t('file.share.permissionSettings')"
      @click-left="handleClose"
      @click-right="handleConfirm"
    >
      <i class="iconfont icon-back" slot="left" />
      <span :class="['btn btn-text', saveDisabled && 'disabled']" slot="right">{{$t('base.save')}}</span>
    </van-nav-bar>
    <div class="change-perms">
      <div class="check-item">
        <div class="check-item-title">
          {{$t('file.share.scope')}}
          <p v-show="access === 'public'">分享需符合国家法律法规，否则无法分享</p>
        </div>
        <div
          v-if="!actionItem.is_share_link_public_access_disabled"
          :class="['check-item-choice']"
          @click="changeAccess('public')"
        >
          {{$t('file.share.anyoneCanAccess')}}
          <svg-icon v-if="access === 'public'" icon="Selected1" cls="type-icon" />
        </div>
        <div :class="['check-item-choice']" @click="changeAccess('company')">
          {{$t('file.share.memberOnlyAccess')}}
          <svg-icon v-if="access !== 'public'" icon="Selected1" cls="type-icon" />
        </div>
      </div>

      <div class="check-item">
        <div class="check-item-title">{{$t('file.share.accessPermisson')}}</div>
        <div :class="['check-item-choice']">
          可预览
          <van-switch
            :class="[actionItem.is_share_force_op_limit_switch && 'van-switch--disabled']"
            :value="true"
            :disabled="true"
          />
        </div>
        <div
          v-if="enableSelectDownload"
          :class="['check-item-choice']"
          @click="changePreview(!disable_download)"
        >
          可下载
          <van-switch
            :class="[actionItem.is_share_force_op_limit_switch]"
            :value="!disable_download"
          />
        </div>
        <div
          v-if="isShowEditSwitch"
          :class="['check-item-choice']"
          @click="changeEdit(!is_share_wps_edit)"
        >
          可在线编辑
          <van-switch
            :class="[actionItem.is_share_force_op_limit_switch]"
            :value="is_share_wps_edit"
          />
        </div>
      </div>

      <div class="perm-item date-item" @click="toggleDateTimePicker">
        <span class="label">{{$t('file.share.visitDuration')}}</span>
        <span class="expire-date">
          <span>{{due_time ? expireDate : $t('file.share.neverExpire')}}</span>
          <i v-if="due_time" class="iconfont icon-close-small" @click.stop="clearDate" />
          <i v-else class="iconfont icon-arrow-next"></i>
        </span>
      </div>

      <div class="switch-item">
        <div :class="['switch-item-choice']">
          {{$t('file.share.limitPreview')}}
          <van-switch
            :class="[actionItem.is_share_force_op_limit_switch && 'van-switch--disabled']"
            :value="is_preview_limit"
            :disabled="actionItem.is_share_force_op_limit_switch"
            @input="onPreviewLimitSwitch"
          />
        </div>
        <div v-show="is_preview_limit" :class="['switch-item-choice']">
          {{$t('file.share.limitPreviewCount')}}
          <van-field
            class="van-field"
            v-model="preview_limit"
            type="number"
            maxlength="6"
            input-align="right"
            clearable
            @input="onPreviewCountChanged"
          />
        </div>
      </div>
      <div v-show="previewCountError" class="field-error-container">
        <i class="iconfont icon-state-error"></i>
        <div
          v-if="!preview_limit || preview_limit < 0"
          class="field-error"
        >{{$t('file.share.limitCountTooSmall')}}</div>
      </div>

      <div v-show="enableSelectDownload && !disable_download" class="switch-item">
        <div :class="['switch-item-choice']">
          {{$t('file.share.limitDownload')}}
          <van-switch
            :class="[actionItem.is_share_force_op_limit_switch && 'van-switch--disabled']"
            :value="is_download_limit_v2"
            :disabled="actionItem.is_share_force_op_limit_switch"
            @input="onDownloadLimitSwitch"
          />
        </div>
        <div v-show="is_download_limit_v2" :class="['switch-item-choice']">
          {{$t('file.share.limitDownloadCount')}}
          <van-field
            class="van-field"
            v-model="download_limit_v2"
            type="number"
            maxlength="6"
            input-align="right"
            clearable
            @input="onDownloadCountChanged"
          />
        </div>
      </div>
      <div v-show="downloadCountError" class="field-error-container">
        <i class="iconfont icon-state-error"></i>
        <div
          v-if="!download_limit_v2 || download_limit_v2 < 0"
          class="field-error"
        >{{$t('file.share.limitCountTooSmall')}}</div>
      </div>

      <div class="perm-item">
        <span class="label">{{$t('file.share.passowrd')}}</span>
        <span v-show="!password" class="auto-psw" @click="autoPsw">{{$t('file.share.autoGenerate')}}</span>
        <van-field
          ref="field"
          v-model="password"
          :placeholder="$t('file.share.passowrdPlaceHolder')"
          spellcheck="false"
          input-align="right"
          maxlength="32"
          type="text"
          clearable
        />
      </div>
      <div v-show="pswError" class="field-error-container">
        <i class="iconfont icon-state-error"></i>
        <div class="field-error">{{$t('file.share.pswErrorTips')}}</div>
      </div>

      <div class="watermark-item">
        <!-- <div class="watermark-item-title">{{$t('file.share.previewWatermark')}}</div>

        <div v-if="forceWatermark">
          <div class="watermark-item-choice">{{$t('file.share.showWatermark')}}</div>
          <div class="watermark-item-text">{{watermark_customize_content}}</div>
        </div>
        <div v-else>
          <div class="watermark-item-choice">{{$t('file.share.showCustomWatermark')}}</div>
          <van-field
            class="van-field"
            v-model="watermark_customize_content"
            type="text"
            maxlength="32"
            @input="changeWatermark"
            :placeholder="$t('file.share.tipsCustomWatermark')"
          />
        </div> -->
      </div>
    </div>
    <van-popup
      class="normal-sheet sheet-datetime-picker"
      v-model="showDateTimePicker"
      position="bottom"
    >
      <van-datetime-picker
        v-model="dateTime"
        type="date"
        :min-date="minDate"
        @cancel="toggleDateTimePicker"
        @confirm="changeDueTime"
      />
    </van-popup>
  </div>
</template>
<script>
import { i18n } from '@/utils/i18n'
import { toast, formatDate, confirm, getDefaultDueTime } from '@/utils/common'
import SvgIcon from '../utils/SvgIcon'
import { wpsShareEditOnline } from '../../utils/fileUtils'
import ShareUtils from '../../utils/ShareUtils'

/**
 * 分享管控的分享权限设置页面
 */
export default {
  name: 'ChangePermsShareManager',
  i18n,
  components: {
    SvgIcon
  },
  props: {
    actionName: String,
    actionItem: Object,
    headerItem: Object,
    perms: Object
  },
  model: {
    prop: 'perms',
    event: 'perms-set'
  },
  data () {
    return {
      saveDisabled: false,
      access: this.perms.access,
      disable_download: this.perms.disable_download,
      is_share_wps_edit: this.perms.is_share_wps_edit,
      is_preview_limit: this.perms.is_preview_limit,
      preview_limit: this.perms.preview_limit,
      is_download_limit_v2: this.perms.is_download_limit_v2,
      download_limit_v2: this.perms.download_limit_v2,
      password: this.perms.password,
      is_watermark_customize_content: this.perms.is_watermark_customize_content,
      watermark_customize_content: this.perms.watermark_customize_content,
      due_time: this.perms.due_time * 1000,
      dateTime: this.perms.due_time
        ? new Date(this.perms.due_time * 1000)
        : getDefaultDueTime(),
      showDateTimePicker: false,
      minDate: new Date()
    }
  },
  computed: {
    expireDate () {
      return formatDate(this.due_time, '%YY-%MM-%DD')
    },
    enableSelectDownload () {
      return !this.actionItem.is_share_link_download_disabled
    },
    forceWatermark () {
      return (
        this.actionItem.is_share_watermark_customize_content_switch ||
        this.actionItem.is_share_watermark_creator_account
      )
    },
    previewCountError () {
      return (
        this.is_preview_limit &&
        (!this.preview_limit ||
          this.preview_limit <= 0 ||
          (this.actionItem.share_max_preview_limit > 0 &&
            this.preview_limit > this.actionItem.share_max_preview_limit))
      )
    },
    downloadCountError () {
      return (
        this.is_download_limit_v2 &&
        (!this.download_limit_v2 ||
          this.download_limit_v2 <= 0 ||
          (this.actionItem.share_max_download_limit > 0 &&
            this.download_limit_v2 > this.actionItem.share_max_download_limit))
      )
    },
    pswError () {
      return this.actionItem.is_share_force_passwd_switch && !this.password
    },
    isShowEditSwitch () {
      return wpsShareEditOnline(this.actionItem)
    }
  },
  watch: {},
  methods: {
    handleClose () {
      const data = {
        access: this.access,
        disable_download: this.disable_download,
        is_preview_limit: this.is_preview_limit,
        preview_limit: this.preview_limit,
        is_download_limit_v2: this.is_download_limit_v2,
        download_limit_v2: this.download_limit_v2,
        password: this.password,
        is_watermark_customize_content: this.is_watermark_customize_content,
        watermark_customize_content: this.watermark_customize_content,
        due_time: parseInt(this.due_time / 1000)
      }
      let changed = !this.isPermsEquals(this.perms, data)
      if (!changed) {
        this.$emit('close-popup')
      } else {
        confirm({
          className: 'dialog',
          message: i18n.t('file.share.confirmSave'),
          confirmButtonText: i18n.t('base.save'),
          cancelButtonText: i18n.t('base.notsave')
        })
          .then(() => {
            if (this.checkFieldValid()) {
              this.$emit('perms-set', data)
              toast(i18n.t('file.share.accessPermissonUpdated'))
              this.$emit('close-popup')
            } else {
              toast(i18n.t('file.share.shareFieldErrorTips'))
            }
          })
          .catch(() => {
            this.$emit('close-popup')
          })
      }
    },
    handleConfirm () {
      if (this.checkFieldValid()) {
        const data = {
          access: this.access,
          disable_download: this.disable_download,
          is_preview_limit: this.is_preview_limit,
          preview_limit: this.preview_limit,
          is_download_limit_v2: this.is_download_limit_v2,
          download_limit_v2: this.download_limit_v2,
          is_share_wps_edit: this.is_share_wps_edit,
          password: this.password,
          is_watermark_customize_content: this.is_watermark_customize_content,
          watermark_customize_content: this.watermark_customize_content,
          due_time: parseInt(this.due_time / 1000)
        }
        this.$emit('perms-set', data)
        toast(i18n.t('file.share.accessPermissonUpdated'))
        this.$emit('close-popup')
      } else {
        toast(i18n.t('file.share.shareFieldErrorTips'))
      }
    },
    isPermsEquals (oldPerms, newPerms) {
      let equals =
        oldPerms.access === newPerms.access &&
        oldPerms.disable_download === newPerms.disable_download &&
        ShareUtils.stringEquals(oldPerms.password, newPerms.password) &&
        oldPerms.due_time === newPerms.due_time
      let previewEquals =
        oldPerms.is_preview_limit === newPerms.is_preview_limit &&
        (oldPerms.is_preview_limit
          ? oldPerms.preview_limit === newPerms.preview_limit
          : true)
      let downloadEqual =
        oldPerms.is_download_limit_v2 === newPerms.is_download_limit_v2 &&
        (oldPerms.is_download_limit_v2
          ? oldPerms.download_limit_v2 === newPerms.download_limit_v2
          : true)
      let watermarkEquals =
        oldPerms.is_watermark_customize_content ===
          newPerms.is_watermark_customize_content &&
        (oldPerms.is_watermark_customize_content
          ? oldPerms.watermark_customize_content ===
            newPerms.watermark_customize_content
          : true)
      return equals && previewEquals && downloadEqual && watermarkEquals
    },
    onPreviewLimitSwitch (checked) {
      this.is_preview_limit = checked
      if (this.actionItem.share_default_preview_limit > 0) {
        this.preview_limit = this.actionItem.share_default_preview_limit
      } else if (this.perms.preview_limit > 0) {
        this.preview_limit = this.perms.preview_limit
      } else {
        this.preview_limit = 10
      }
    },
    onPreviewCountChanged (count) {
      if (!count || count === '') {
        this.preview_limit = 0
      } else {
        let limit = parseInt(count.replace(/^0+/, ''))
        if (
          this.actionItem.share_max_preview_limit > 0 &&
          limit > this.actionItem.share_max_preview_limit
        ) {
          limit = this.actionItem.share_max_preview_limit
        }
        this.preview_limit = limit
      }
    },
    onDownloadLimitSwitch (checked) {
      this.is_download_limit_v2 = checked
      if (this.actionItem.share_default_download_limit > 0) {
        this.download_limit_v2 = this.actionItem.share_default_download_limit
      } else if (this.perms.download_limit_v2 > 0) {
        this.download_limit_v2 = this.perms.download_limit_v2
      } else {
        this.download_limit_v2 = 10
      }
    },
    onDownloadCountChanged (count) {
      if (!count || count === '') {
        this.download_limit_v2 = 0
      } else {
        let limit = parseInt(count.replace(/^0+/, ''))
        if (
          this.actionItem.share_max_download_limit > 0 &&
          limit > this.actionItem.share_max_download_limit
        ) {
          limit = this.actionItem.share_max_download_limit
        }
        this.download_limit_v2 = limit
      }
    },
    autoPsw () {
      this.password = ShareUtils.generatePsw()
    },
    changeAccess (key) {
      if (key === 'public' && key) {
        confirm({
          className: 'dialog',
          message: '链接分享后可编辑，仅支持分享给公司成员，是否选择公司成员后继续',
          confirmButtonText: '继续',
          cancelButtonText: '取消'
        })
          .then(() => {

          })
          .catch(() => {
            this.is_share_wps_edit = false
            this.access = key
          })
        return
      }
      this.access = key
    },
    changePreview (key) {
      this.disable_download = key
      if (
        this.disable_download &&
        !this.actionItem.is_share_force_op_limit_switch
      ) {
        this.is_download_limit_v2 = false
        this.download_limit_v2 = this.perms.download_limit_v2
      }
    },
    changeEdit (key) {
      if (this.access === 'public' && key) {
        confirm({
          className: 'dialog',
          message: '链接分享后可编辑，仅支持分享给公司成员，是否选择公司成员后继续',
          confirmButtonText: '继续',
          cancelButtonText: '取消'
        })
          .then(() => {
            this.is_share_wps_edit = key
            this.changeAccess('company')
          })
          .catch(() => {

          })
        return
      }
      this.is_share_wps_edit = key
    },
    changeWatermark (watermark) {
      if (watermark) {
        // 点击的是不显示水印
        this.is_watermark_customize_content = true
      } else {
        this.is_watermark_customize_content = false
      }
    },
    clearDate () {
      this.due_time = 0
    },
    toggleDateTimePicker () {
      this.showDateTimePicker = !this.showDateTimePicker
    },
    changeDueTime (date) {
      this.due_time =
        new Date(date.toLocaleDateString()).getTime() + 86400000 - 1000
      this.toggleDateTimePicker()
    },
    checkFieldValid () {
      return (
        !this.previewCountError && !this.downloadCountError && !this.pswError
      )
    }
  }
}
</script>
<style lang="postcss" scoped>
@import 'variables';

.share-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  transform: translateZ(0);
}

.change-perms-view {
  background-color: var(--pageBgColor);
}

.change-perms {
  width: 100%;
  height: 0px;
  flex: 1 0 auto;
  overflow: auto;
  & .check-item {
    margin-top: 30px;

    & .check-item-title {
      color: var(--secondlyTitle);
      font-size: 12px;
      height: 17px;
      line-height: 17px;
      margin-bottom: 6px;
      padding: 0 15px;
      display: flex;
      justify-content: space-between;
    }

    & .check-item-choice {
      background-color: #fff;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      & + .check-item-choice {
        border-top: 1px solid var(--sepLineColor);
      }

      &.disabled {
        color: #d1d4e0;
      }
    }
  }

  & .field-error-container {
    display: flex;
    padding: 0 15px;
    margin-top: 5px;

    & .iconfont {
      color: var(--dangerColor);
      transform: scale(0.8);
    }

    & .field-error {
      padding: 0 2px;
      font-size: 12px;
      color: var(--dangerColor);
    }
  }

  & .perm-item {
    background-color: #fff;
    padding: 0 15px;
    height: 50px;
    line-height: 50px;
    margin-top: 30px;
    display: flex;
    align-items: center;

    &.date-item {
      padding-right: 0;
    }

    & .label {
      flex: 1 0 auto;
    }

    & .auto-psw {
      flex: 1 0 auto;
      padding: 0 15px;
      color: var(--primaryColor);
    }

    & .van-field {
      // flex: 1 1 auto;
      font-size: 16px;
      line-height: 50px;
      padding: 0;
    }

    & .expire-date {
      color: var(--secondlyText);

      & .iconfont {
        color: var(--contentIcon);
        display: inline-block;
        padding-left: 10px;
        height: 100%;
        padding-right: 15px;
      }
    }

    & input {
      text-align: right;
    }
  }

  & .switch-item {
    margin-top: 30px;

    & .switch-item-choice {
      background-color: #fff;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      flex: 1 0 auto;
      justify-content: space-between;
      align-items: center;

      & + .switch-item-choice {
        border-top: 1px solid var(--sepLineColor);
      }

      &.disabled {
        color: #d1d4e0;
      }

      & .van-field {
        flex: 1 0 auto;
        width: auto;
        & input {
          color: var(--secondlyText);
        }
      }
    }
  }

  & .watermark-item {
    margin-top: 30px;
    margin-bottom: 30px;

    & .watermark-item-title {
      color: var(--secondlyTitle);
      font-size: 12px;
      height: 17px;
      line-height: 17px;
      margin-bottom: 6px;
      padding: 0 15px;
    }

    & .watermark-item-choice {
      background-color: #fff;
      height: 50px;
      line-height: 50px;
      padding: 0 15px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;

      & + .watermark-item-choice {
        border-top: 1px solid var(--sepLineColor);
      }

      &.disabled {
        color: #d1d4e0;
      }
    }

    & .watermark-item-text {
      padding: 0 15px;
      box-sizing: border-box;
      line-height: 50px;
      background-color: #fff;
      height: 50px;
      font-size: 16px;
      color: #848484;
    }

    & .van-field {
      // flex: 1 1 auto;
      font-size: 16px;
      line-height: 50px;
      padding: 0 15px;

      & input {
        color: var(--secondlyText);
      }
    }
  }
}
</style>
